import React from "react";
import { Drawer } from "antd";
import styled from "styled-components";

const CustomDrawerWrapper = styled.div`
  // .custom-modal .ant-modal-body {
  //   max-height: 720px;
  //   max-width: 1196px;
  // }

  .custom-modal .ant-modal-footer .ant-btn {
    background-color: #2c963d;
    border-color: #2c963d;
    color: white;

    &:focus,
    &:active {
      outline: none;
      border-color: transparent;
    }
  }

  .custom-modal .ant-modal-footer .ant-btn.cancel-btn {
    background-color: transparent;
    border-color: #ccc;
    color: #000;

    &:hover {
      background-color: #f0f0f0;
    }
  }
`;

const ReusableDrawer = ({
  closable = true,
  open,
  onCancel,
  onOk,
  title,
  footer,
  children,
  setOpen,
}) => {
  return (
    <CustomDrawerWrapper>
      <Drawer
        title={title}
        open={open}
        onOk={onOk}
        onClose={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        className="custom-drawer"
        footer={footer}
        width={1196}
        height={720}
        closable={closable}
      >
        {children}
      </Drawer>
    </CustomDrawerWrapper>
  );
};

export default ReusableDrawer;
